/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/tr_TR';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Biçimlendirilmiş HTML düzenleyicisine erişin"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Erişilebilirlik Kontrolü"
  },
  "action_to_take_b626a99a": {
    "message": "Atılacak adım:"
  },
  "add_8523c19b": {
    "message": "Ekle"
  },
  "add_a_caption_2a915239": {
    "message": "Altyazı ekle"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Görsel için alternatif metin ekleyin"
  },
  "add_another_f4e50d57": {
    "message": "Başka bir tane ekle"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Alt yazı ekle"
  },
  "add_image_60b2de07": {
    "message": "Görsel Ekle"
  },
  "add_one_9e34a6f8": {
    "message": "Bir tane ekle!"
  },
  "additional_considerations_f3801683": {
    "message": "Ek hususlar"
  },
  "address_applied_64269b0b": {
    "message": "Adres uygulandı"
  },
  "address_removed_fcb496e0": {
    "message": "Adres kaldırıldı"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Aynı URL’ye sahip bitişik bağlantılar tek bir bağlantı olmalıdır."
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "Hizala"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Eşleştirme ve Listeler"
  },
  "all_4321c3a1": {
    "message": "Tümü"
  },
  "all_apps_a50dea49": {
    "message": "Tüm Uygulamalar"
  },
  "allow_media_download_16dcf2bd": {
    "message": "Medya indirmeye izin ver"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "Transkript indirmeye izin ver"
  },
  "alpha_15d59033": {
    "message": "Alfa"
  },
  "alphabetical_55b5b4e0": {
    "message": "Alfabetik"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Alternatif metin 120 karakterden uzun olmamalıdır."
  },
  "alt_text_611fb322": {
    "message": "Etiket Metni"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (Coproduct)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Dosya okunurken hata oluştu"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Ağ isteğinde bulunurken bir hata oluştu"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Medya dosyası yüklenirken hata oluştu."
  },
  "and_7fcc2911": {
    "message": "Ve"
  },
  "angle_c5b4ec50": {
    "message": "Açı"
  },
  "announcement_fb4cb645": {
    "message": "Duyuru"
  },
  "announcement_list_da155734": {
    "message": "Duyuru Listesi"
  },
  "announcements_a4b8ed4a": {
    "message": "Duyurular"
  },
  "apply_781a2546": {
    "message": "Uygula"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Bu dersteki bu Simge Oluşturucu simgesinin tüm örneklerine değişiklikleri uygula"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Sınıra yaklaşıyor"
  },
  "approximately_e7965800": {
    "message": "Yaklaşık"
  },
  "apps_54d24a47": {
    "message": "Uygulamalar"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "İptal etmek istediğinize emin misiniz? Yaptığınız değişiklikler kaydedilmeyebilir."
  },
  "arrows_464a3e54": {
    "message": "Oklar"
  },
  "art_icon_8e1daad": {
    "message": "Sanat Simgesi"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Genişleme oranı korumalıdır"
  },
  "assignment_976578a8": {
    "message": "Ödev"
  },
  "assignments_1e02582c": {
    "message": "Ödevler"
  },
  "asterisk_82255584": {
    "message": "Yıldız"
  },
  "attributes_963ba262": {
    "message": "Özellikler"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Ses ve video kaydı desteklenmiyor; lütfen başka bir tarayıcı kullanın."
  },
  "audio_options_feb58e2c": {
    "message": "Ses Seçenekleri"
  },
  "audio_options_tray_33a90711": {
    "message": "Ses Seçenekleri Tepsisi"
  },
  "audio_player_for_title_20cc70d": {
    "message": "{ title } ses oynatıcı"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Otomatik kaydedilmiş içerik var. Bunun yerine otomatik kaydedilen içeriği yüklemek ister misiniz?"
  },
  "available_folders_694d0436": {
    "message": "Mevcut klasörler"
  },
  "background_1bc88842": {
    "message": "Arka Plan"
  },
  "backslash_b2d5442d": {
    "message": "Ters eğik çizgi"
  },
  "bar_ec63ed6": {
    "message": "Çubuk"
  },
  "basic_554cdc0a": {
    "message": "Temel"
  },
  "because_501841b": {
    "message": "Çünkü"
  },
  "below_81d4dceb": {
    "message": "Altında"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Büyük Çember"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Binom Katsayısı"
  },
  "black_4cb01371": {
    "message": "Siyah"
  },
  "blue_daf8fea9": {
    "message": "Mavi"
  },
  "bold_applied_42d547b7": {
    "message": "Kalın uygulandı"
  },
  "bold_removed_da474a5c": {
    "message": "Kalın kaldırıldı"
  },
  "border_5b08b06d": {
    "message": "Kenarlık"
  },
  "bottom_15a2a9be": {
    "message": "Alt"
  },
  "bottom_third_5f5fec1d": {
    "message": "Alt Üçte Bir"
  },
  "bowtie_5f9629e4": {
    "message": "Papyon"
  },
  "brick_f2656265": {
    "message": "Tuğla"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "İptal"
  },
  "cap_product_3a5265a6": {
    "message": "Cap Ürünü"
  },
  "caption_manager_aae0906f": {
    "message": "Altyazı Yöneticisi"
  },
  "center_align_e68d9997": {
    "message": "Ortala"
  },
  "centered_dot_64d5e378": {
    "message": "Ortalanmış nokta"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Ortalanmış yatay noktalar"
  },
  "change_alt_text_92654906": {
    "message": "Alternatif metni değiştir"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Başlık etiketini paragraf olarak değiştir"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Yalnızca bu başlığın düzeyini değiştir"
  },
  "change_text_color_1aecb912": {
    "message": "Kullanıcının Outcomes Mastery sekmesini görüntülemesine ve ders düzeyinde kazanım yeterlik ölçeklerini ayarlamasına izin verir."
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "Değişiklikler, bu sayfayı kaydettikten sonra uygulanacaktır."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Yaptığınız değişiklikler kaydedilmemiş olabilir."
  },
  "characters_9d897d1c": {
    "message": "Karakterler"
  },
  "characters_no_spaces_485e5367": {
    "message": "Karakter (boşluksuz)"
  },
  "check_accessibility_3c78211c": {
    "message": "Kullanıcının Ders Ayarları''nda bir uygulamayı elle silmesine izin verir."
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Erişilebilirlik sorunları denetleniyor"
  },
  "chi_54a32644": {
    "message": "Ki"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Alt yazı dosyasını seçin"
  },
  "choose_usage_rights_33683854": {
    "message": "Kullanıcı haklarını seçin..."
  },
  "circle_484abe63": {
    "message": "Çember"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "sıralanmamış listeyi yuvarlak içine al"
  },
  "clear_2084585f": {
    "message": "Temizle"
  },
  "clear_image_3213fe62": {
    "message": "Görseli temizle"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "HTML düzenleyicisi için tıklayın veya Shift ile tıklayın."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "{ imageName } görselini eklemek için tıklayınız"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Önizlemeyi gizlemek için tıklayın"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Düzenleyiciye bağlantı eklemek için tıklayın."
  },
  "click_to_show_preview_faa27051": {
    "message": "Önizlemeyi göstermek için tıklayın"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Bir menü ya da diyalog kapatır. Ayrıca sizi düzenleme alanına götürür"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Erişilebilirlik Denetleyicisini Kapat"
  },
  "close_d634289d": {
    "message": "Kapat"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "Kapalı altyazı dosyası { maxKb } KB’den küçük olmalıdır"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Kapalı Altyazılar/Altyazılar"
  },
  "clubs_suit_c1ffedff": {
    "message": "Sinek (İskambil)"
  },
  "collab_575ac7bc": {
    "message": "Collab"
  },
  "collaborations_5c56c15f": {
    "message": "İşbirliğine Yönelik Çalışmalar"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "{ types } gizlemek için daraltın"
  },
  "color_a363e1b0": {
    "message": "Renk"
  },
  "color_contrast_4c418add": {
    "message": "Renk Kontrastı"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Renk Kontrast Oranı"
  },
  "color_picker_6b359edf": {
    "message": "Renk Seçici"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Renk Seçici ({ colorName } seçildi)"
  },
  "color_popup_af39810f": {
    "message": "Bağlantı değiştirme mantığını yalnızca seçili öge listesine uygula;\nmetinlerin tümüne değil."
  },
  "column_e1ae5c64": {
    "message": "Notu Notlandırılmamışlara Uygula"
  },
  "column_group_1c062368": {
    "message": "Ayarları Uygula"
  },
  "complex_numbers_a543d004": {
    "message": "Karmaşık Sayılar"
  },
  "computer_1d7dfa6f": {
    "message": "Bilgisayar"
  },
  "congruent_5a244acd": {
    "message": "Kongruent"
  },
  "contains_311f37b7": {
    "message": "İçerir"
  },
  "content_1440204b": {
    "message": "İçerik"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Düzenleyicideki içerik değiştirilecek. Özgün içeriği korumak için İptal’e basın."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "İçerik hâlâ yükleniyor; devam ederseniz düzgün bir şekilde gömülmeyecektir."
  },
  "content_subtype_5ce35e88": {
    "message": "İçerik Alt Türü"
  },
  "content_type_2cf90d95": {
    "message": "İçerik Tipi"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "YouTube içeriğine devam et"
  },
  "coproduct_e7838082": {
    "message": "Yan ürün"
  },
  "copyright_holder_66ee111": {
    "message": "Telif Sahibi:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "İçerik eklenemedi: \"{ itemType }\" öğeleri şu anda Canvas’ta desteklenmiyor."
  },
  "count_40eced3b": {
    "message": "Önce..."
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 kelime}\n    one {1 kelime}\n  other {# kelime}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# öğe yüklendi}\n  other {# öğe yüklendi}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Ders Belgeleri"
  },
  "course_files_62deb8f8": {
    "message": "Ders Dosyaları"
  },
  "course_files_a31f97fc": {
    "message": "Ders dosyaları"
  },
  "course_images_f8511d04": {
    "message": "Ders Görselleri"
  },
  "course_link_b369426": {
    "message": "Ders Bağlantısı"
  },
  "course_links_b56959b9": {
    "message": "Ders Bağlantıları"
  },
  "course_media_ec759ad": {
    "message": "Ders Medyası"
  },
  "course_navigation_dd035109": {
    "message": "Ders Gezinme Menüsü"
  },
  "create_icon_110d6463": {
    "message": "Simge Oluştur"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Simge Oluşturucu Simgesi Oluştur"
  },
  "creative_commons_license_725584ae": {
    "message": "Creative Commons Lisansı:"
  },
  "crop_image_41bf940c": {
    "message": "Görseli kırp"
  },
  "crop_image_807ebb08": {
    "message": "Görseli Kırp"
  },
  "cup_product_14174434": {
    "message": "Cup Çarpımı"
  },
  "current_image_f16c249c": {
    "message": "Mevcut Görsel"
  },
  "current_link_945a47ee": {
    "message": "Mevcut Bağlantı"
  },
  "current_volume_level_c55ab825": {
    "message": "Mevcut Ses Seviyesi"
  },
  "custom_6979cd81": {
    "message": "Özelleştir"
  },
  "cyan_c1d5f68a": {
    "message": "Cam göbeği"
  },
  "dagger_57e0f4e5": {
    "message": "Hançer"
  },
  "date_added_ed5ad465": {
    "message": "Eklendiği Tarih"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Dekoratif Simge"
  },
  "decorative_image_fde98579": {
    "message": "Dekoratif görsel"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Dekoratif { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "İçerden başlatma sınırını azalt"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Zengin İçerik Alanını küçült"
  },
  "deep_purple_bb3e2907": {
    "message": "Koyu Mor"
  },
  "default_9db103d": {
    "message": "Varsayılan"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "varsayılan madde işaretli sırasız liste"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "varsayılan sayısal sıralı liste"
  },
  "definite_integral_fe7ffed1": {
    "message": "Belirli İntegral"
  },
  "degree_symbol_4a823d5f": {
    "message": "Derece Simgesi"
  },
  "delimiters_4db4840d": {
    "message": "Ayıraçlar"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Simgeyi tanımlayın)"
  },
  "describe_the_type_ff448da5": {
    "message": "({ TYPE } öğesini tanımlayın)"
  },
  "description_436c48d7": {
    "message": "Açıklama"
  },
  "details_98a31b68": {
    "message": "Ayrıntılar"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Çapraz noktalar"
  },
  "diamond_b8dfe7ae": {
    "message": "Elmas"
  },
  "diamonds_suit_526abaaf": {
    "message": "Karo (İskambil)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Boyut Türü"
  },
  "directionality_26ae9e08": {
    "message": "Yazım yönü"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "LaTeX’i doğrudan düzenle"
  },
  "disable_preview_222bdf72": {
    "message": "Önizlemeyi devre dışı bırak"
  },
  "discussion_6719c51d": {
    "message": "Tartışma"
  },
  "discussions_a5f96392": {
    "message": "Tartışmalar"
  },
  "discussions_index_6c36ced": {
    "message": "Tartışma Başlıkları"
  },
  "disjoint_union_e74351a8": {
    "message": "Ayrık Birleşim"
  },
  "display_options_315aba85": {
    "message": "Gösterim Seçenekleri"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Metin Bağlantısı Göster (Yeni sekmede açılır)"
  },
  "div_applied_49ad83fc": {
    "message": "Div uygulandı"
  },
  "div_removed_d13f8e17": {
    "message": "Div kaldırıldı"
  },
  "division_sign_72190870": {
    "message": "Bölme İşareti"
  },
  "document_678cd7bf": {
    "message": "Belge"
  },
  "documents_81393201": {
    "message": "Belgeler"
  },
  "done_54e3d4b6": {
    "message": "Tamam"
  },
  "double_dagger_faf78681": {
    "message": "Çift Hançer"
  },
  "down_5831a426": {
    "message": "Aşağı"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Yukarı ve sola çapraz ok"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Yukarı ve sağa çapraz ok"
  },
  "download_filename_2baae924": {
    "message": "{ filename } indir"
  },
  "downward_arrow_cca52012": {
    "message": "Aşağı ok"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Aşağı bakan üçgen"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Buraya bir Dosya Sürükleyin"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Sürükleyip bırakın ya da bilgisayarınıza gözatın"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Sürükleme tutamacı. Yeniden boyutlandırmak için yukarı ve aşağı okları kullanın"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Teslim Tarihi: Birden Çok Gün"
  },
  "due_when_7eed10c6": {
    "message": "Son tarih: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Bu simge örneği için alternatif metni düzenle"
  },
  "edit_c5fbea07": {
    "message": "Düzenle"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Ders Bağlantısını Düzenle"
  },
  "edit_equation_f5279959": {
    "message": "Denklemi Düzenle"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Mevcut Simge Oluşturucu Simgesini Düzenle"
  },
  "edit_icon_2c6b0e91": {
    "message": "Simgeyi Düzenle"
  },
  "edit_link_7f53bebb": {
    "message": "Bağlantıyı Düzenle"
  },
  "editor_status_bar_653f44ee": {
    "message": "Düzenleyici Durum Çubuğu"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "{ start } ile başlayan öğe"
  },
  "embed_828fac4a": {
    "message": "Göm"
  },
  "embed_code_314f1bd5": {
    "message": "Gömme Kodu"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Harici Araçtan içerik Ekle"
  },
  "embed_image_1080badc": {
    "message": "Görsel Ekle"
  },
  "embed_video_a97a64af": {
    "message": "Videoyu Göm"
  },
  "embedded_content_aaeb4d3d": {
    "message": "gömülü içerik"
  },
  "empty_set_91a92df4": {
    "message": "Boş Küme"
  },
  "encircled_dot_8f5e51c": {
    "message": "Çember İçinde Nokta"
  },
  "encircled_minus_72745096": {
    "message": "Çember İçinde Eksi"
  },
  "encircled_plus_36d8d104": {
    "message": "Çember İçinde Artı"
  },
  "encircled_times_5700096d": {
    "message": "Çember İçinde Çarpı"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Mühendislik Simgesi"
  },
  "english_icon_25bfe845": {
    "message": "İngilizce Simgesi"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Hizmet belirteci kimliğini girin"
  },
  "enter_replacement_text_17631bbc": {
    "message": "değiştirme metni girin"
  },
  "enter_search_text_26cb4459": {
    "message": "arama metni girin"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (Varyant)"
  },
  "equals_sign_c51bdc58": {
    "message": "Eşittir İşareti"
  },
  "equation_1c5ac93c": {
    "message": "Denklem"
  },
  "equation_editor_39fbc3f1": {
    "message": "Denklem Düzenleyici"
  },
  "equilibrium_6ff3040b": {
    "message": "Denge"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Eşdeğerlik Sınıfı"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Eşdeğer (Özdeşlik)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "Vardır"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Sınavlar"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Önizlemeyi varsayılan olarak genişlet"
  },
  "expand_to_see_types_f5d29352": {
    "message": "{ types } öğelerini görmek için genişletin"
  },
  "external_link_d3f9e62a": {
    "message": "Harici Bağlantı"
  },
  "external_tool_frame_70b32473": {
    "message": "Harici araç içeriğini yüklemek için tıklayın"
  },
  "external_tools_6e77821": {
    "message": "Harici Araçlar"
  },
  "extra_large_b6cdf1ff": {
    "message": "Ekstra Büyük"
  },
  "extra_small_9ae33252": {
    "message": "Çok Küçük"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Ders Dışı Simgesi"
  },
  "f_function_fe422d65": {
    "message": "F (fonksiyon)"
  },
  "fail_544e5dde": {
    "message": "BAŞARISIZ (FAIL)"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Dosya içeriği alınamadı"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Harici araçtan içerik alınamadı"
  },
  "file_name_8fd421ff": {
    "message": "Dosya adı"
  },
  "file_preview_21667a6e": {
    "message": "Dosya önizlemesi"
  },
  "file_preview_for_filename_ab314195": {
    "message": "{ fileName } için dosya önizlemesi"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Dosya depolama kotası aşıldı"
  },
  "file_url_c12b64be": {
    "message": "Dosya URL"
  },
  "filename_file_icon_602eb5de": {
    "message": "{ filename } dosya simgesi"
  },
  "filename_image_preview_6cef8f26": {
    "message": "{ filename } görsel önizlemesi"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "{ filename } metin önizlemesi"
  },
  "files_c300e900": {
    "message": "Dosyalar"
  },
  "files_index_af7c662b": {
    "message": "Dosya Başlıkları"
  },
  "find_8d605019": {
    "message": "Ara"
  },
  "find_and_replace_6e345933": {
    "message": "Bul ve Değiştir"
  },
  "finish_bc343002": {
    "message": "Tamamla"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Başlık hiyerarşisini düzelt"
  },
  "flat_music_76d5a5c3": {
    "message": "Bemol (Müzik)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Öğe seçenekleri araç çubuğuna odaklan"
  },
  "folder_tree_fbab0726": {
    "message": "Klasör ağacı"
  },
  "for_all_b919f972": {
    "message": "Her için"
  },
  "format_4247a9c5": {
    "message": "Format"
  },
  "format_as_a_list_142210c3": {
    "message": "Liste olarak biçimlendir"
  },
  "formatting_5b143aa8": {
    "message": "Biçimlendirme"
  },
  "forward_slash_3f90f35e": {
    "message": "Bölü işareti"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Otomatik kaydedilmiş içerik bulundu"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "{ count, plural,\n     =0 {# sonuç}\n    one {# sonuç}\n  other {# sonuç}\n}"
  },
  "fraction_41bac7af": {
    "message": "Kesir"
  },
  "fullscreen_873bf53f": {
    "message": "Tam ekran"
  },
  "gamma_1767928": {
    "message": "Gamma"
  },
  "generating_preview_45b53be0": {
    "message": "Oluşturma önizlemesi..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "{ size } KB’den büyük GIF/PNG görselleri şu anda desteklenmiyor."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Düzenleyicinin menü çubuğuna git"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Düzenleyicinin araç çubuğuna git"
  },
  "grades_a61eba0a": {
    "message": "Notlar"
  },
  "graphics_text_bc9568bc": {
    "message": "Grafik metni"
  },
  "greater_than_e98af662": {
    "message": "Büyüktür"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Büyük veya Eşittir"
  },
  "greek_65c5b3f7": {
    "message": "Yunan"
  },
  "green_15af4778": {
    "message": "Yeşil"
  },
  "grey_a55dceff": {
    "message": "Gri"
  },
  "group_documents_8bfd6ae6": {
    "message": "Belgeleri Grupla"
  },
  "group_files_4324f3df": {
    "message": "Grup tartışması gönderimi sınırlı değil."
  },
  "group_files_82e5dcdb": {
    "message": "Grup dosyaları"
  },
  "group_images_98e0ac17": {
    "message": "Görselleri Grupla"
  },
  "group_isomorphism_45b1458c": {
    "message": "Grup İzomorfizmi"
  },
  "group_link_63e626b3": {
    "message": "Grup Bağlantısı"
  },
  "group_links_9493129e": {
    "message": "Bağlantıları Grupla"
  },
  "group_media_2f3d128a": {
    "message": "Medyayı Grupla"
  },
  "group_navigation_99f191a": {
    "message": "Grup Gezinme Menüsü"
  },
  "h_bar_bb94deae": {
    "message": "H Üst Çizgisi"
  },
  "hat_ea321e35": {
    "message": "Şapka"
  },
  "header_column_f27433cb": {
    "message": "Başlık sütunu"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Başlık satırı ve sütunu"
  },
  "header_row_f33eb169": {
    "message": "Başlık satırı"
  },
  "heading_2_5b84eed2": {
    "message": "Başlık 2"
  },
  "heading_3_2c83de44": {
    "message": "Başlık 3"
  },
  "heading_4_b2e74be7": {
    "message": "Başlık 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Başlık { h } uygulandı"
  },
  "heading_h_removed_745f24a6": {
    "message": "Başlık { h } kaldırıldı"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Başlık düzeyleri atlanmamalıdır."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "{ start } ile başlayan başlık"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Başlıklar 120 karakterden uzun olmamalıdır."
  },
  "health_icon_8d292eb5": {
    "message": "Sağlık Simgesi"
  },
  "hearts_suit_e50e04ca": {
    "message": "Kupa (İskambil)"
  },
  "height_69b03e15": {
    "message": "Yükseklik"
  },
  "hexagon_d8468e0d": {
    "message": "Altıgen"
  },
  "hide_description_bfb5502e": {
    "message": "Açıklamayı gizle"
  },
  "hide_title_description_caf092ef": {
    "message": "{ title } açıklamasını gizle"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Öğe seçenekleri araç çubuğunu etkinleştirmek için bir öğeyi vurgulayın"
  },
  "home_351838cd": {
    "message": "Ana Sayfa"
  },
  "html_code_editor_fd967a44": {
    "message": "HTML kod düzenleyicisi"
  },
  "html_editor_fb2ab713": {
    "message": "HTML Düzenleyici"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Bu dosyayı kullanmak için iznim var."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Telif hakkı bendedir"
  },
  "icon_215a1dc6": {
    "message": "Simge"
  },
  "icon_8168b2f8": {
    "message": "simge"
  },
  "icon_color_b86dd6d6": {
    "message": "Simge Rengi"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Bu özelliği keşfetmeyi planlamıyorum"
  },
  "icon_options_7e32746e": {
    "message": "Simge Seçenekleri"
  },
  "icon_options_tray_2b407977": {
    "message": "Simge Seçenekleri Tepsisi"
  },
  "icon_preview_1782a1d9": {
    "message": "Simge Önizlemesi"
  },
  "icon_shape_30b61e7": {
    "message": "Simge Şekli"
  },
  "icon_size_9353edea": {
    "message": "Simge Boyutu"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Boş bırakılırsa bağlantı metni ders bağlantısı adı olarak görüntülenir"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Kullanım Hakları gerekiyorsa, Dosyalar sayfasında etkinleştirilene kadar dosya yayımlanmaz."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Kullanım haklarını şimdi seçmezseniz, dosya yüklendikten sonra yayımlanmayacaktır."
  },
  "image_8ad06": {
    "message": "Görsel"
  },
  "image_c1c98202": {
    "message": "görsel"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Görsel dosya adları, görsel içeriğini tanımlayan alternatif metin olarak kullanılmamalıdır."
  },
  "image_options_5412d02c": {
    "message": "Görsel Seçenekleri"
  },
  "image_options_tray_90a46006": {
    "message": "Görsel Seçenekleri Yan Menüsü"
  },
  "image_to_crop_3a34487d": {
    "message": "Kırpılacak görsel"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Dosya adı { file } olan görsel"
  },
  "images_7ce26570": {
    "message": "Görseller"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Görseller, görsel içeriğini tanımlayan bir alternatif metin içermelidir."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Sanal Kısım (Karmaşık Sayı)"
  },
  "in_element_of_19ca2f33": {
    "message": "∈ (Elemanıdır)"
  },
  "increase_indent_6af90f7c": {
    "message": "İçerden başlat"
  },
  "increase_rich_content_area_340b775": {
    "message": "Zengin İçerik Alanını büyüt"
  },
  "indefinite_integral_6623307e": {
    "message": "Belirsiz İntegral"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } / { max }"
  },
  "indigo_2035fc55": {
    "message": "Indigo"
  },
  "inference_fed5c960": {
    "message": "Çıkarım"
  },
  "infinity_7a10f206": {
    "message": "∞ (Sonsuzluk)"
  },
  "input_field_for_alpha_678265fd": {
    "message": "alfa için giriş alanı"
  },
  "input_field_for_blue_561e020a": {
    "message": "mavi için giriş alanı"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "yeşil için giriş alanı"
  },
  "input_field_for_red_86a84615": {
    "message": "kırmızı için giriş alanı"
  },
  "insert_593145ef": {
    "message": "Ekle"
  },
  "insert_link_6dc23cae": {
    "message": "Bağlantı Ekle"
  },
  "insert_math_equation_57c6e767": {
    "message": "Matematik Denklemi Ekle"
  },
  "integers_336344e1": {
    "message": "Tamsayılar"
  },
  "intersection_cd4590e4": {
    "message": "Kesişim"
  },
  "invalid_description_991e23bb": {
    "message": "Geçersiz açıklama"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Geçersiz giriş."
  },
  "invalid_file_c11ba11": {
    "message": "Geçersiz Dosya"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Geçersiz dosya türü"
  },
  "invalid_url_cbde79f": {
    "message": "Geçersiz bağlantı"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "Sorun { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "İtalik uygulandı"
  },
  "italic_removed_17cbab6f": {
    "message": "İtalik kaldırıldı"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (Varyant)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Klavye Kısayolları"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Klavye kullanıcıları bağlantılarda Tab tuşuyla gezinir. Aynı hedefe giden iki bitişik bağlantı, klavye kullanıcıları için kafa karıştırıcı olabilir."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Dil Sanatları Simgesi"
  },
  "languages_icon_9d20539": {
    "message": "Diller Simgesi"
  },
  "large_9c5e80e7": {
    "message": "Büyük"
  },
  "large_text_e7ba08cd": {
    "message": "Büyük metin"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "Büyük ({ width } x { height } px)"
  },
  "learn_ad3b3505": {
    "message": "Öğren"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Bitişik bağlantılar hakkında daha fazla bilgi edinin"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Renk kontrastı hakkında daha fazla bilgi edinin"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Sayfa başlıklarını düzenleme hakkında daha fazla bilgi edinin"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Doğru sayfa başlık yapısı hakkında daha fazla bilgi edinin"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Tablo başlıkları hakkında daha fazla bilgi edinin"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Görsellerde alternatif metin kullanımı hakkında daha fazla bilgi edinin"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Tablolarda altyazı kullanımı hakkında daha fazla bilgi edinin"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Dosya adlarını alternatif metin olarak kullanma hakkında daha fazla bilgi edinin"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Listeleri kullanma hakkında daha fazla bilgi edinin"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Tablolarda kapsam özniteliklerini kullanma hakkında daha fazla bilgi edinin"
  },
  "leave_as_is_4facfe55": {
    "message": "Olduğu gibi bırak"
  },
  "left_3ea9d375": {
    "message": "Sol"
  },
  "left_align_43d95491": {
    "message": "Sola hizala"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Sol açılı ayraç"
  },
  "left_arrow_4fde1a64": {
    "message": "Sol ok"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Kancalı sol ok"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Sol tavan"
  },
  "left_curly_brace_1726fb4": {
    "message": "Sol kıvrımlı ayraç"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Sol aşağı zıpkın oku"
  },
  "left_floor_29ac2274": {
    "message": "Sol taban"
  },
  "left_to_right_e9b4fd06": {
    "message": "Soldan Sağa"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Sol yukarı zıpkın oku"
  },
  "leftward_arrow_1e4765de": {
    "message": "Sola ok"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Sola bakan üçgen"
  },
  "less_than_a26c0641": {
    "message": "Küçüktür"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Küçük veya Eşittir"
  },
  "library_icon_ae1e54cf": {
    "message": "Kütüphane Simgesi"
  },
  "light_blue_5374f600": {
    "message": "Açık Mavi"
  },
  "link_7262adec": {
    "message": "Bağlantı"
  },
  "link_options_a16b758b": {
    "message": "Bağlantı Seçenekleri"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "bağlantı türü: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "{ start } ile başlayan metne sahip bağlantı"
  },
  "links_14b70841": {
    "message": "Bağlantılar"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Harici bir siteye bağlantılar."
  },
  "lists_cd1336fc": {
    "message": "Listeler"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Listeler, liste olarak biçimlendirilmelidir."
  },
  "load_more_35d33c7": {
    "message": "Daha Fazla Yükle"
  },
  "loading_25990131": {
    "message": "Yükleniyor..."
  },
  "loading_bde52856": {
    "message": "Yükleniyor"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "Kapalı altyazılar/altyazılar yüklenemedi."
  },
  "loading_external_tool_d839042c": {
    "message": "Harici Araç Yükleniyor"
  },
  "loading_failed_b3524381": {
    "message": "Yükleme Başarısız..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "Yükleme başarısız oldu."
  },
  "loading_folders_d8b5869e": {
    "message": "Klasörler yükleniyor"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "{ fileName } için yer tutucu yükleniyor"
  },
  "loading_please_wait_d276220a": {
    "message": "Yükleniyor, lütfen bekleyin"
  },
  "loading_preview_9f077aa1": {
    "message": "Önizleme yükleniyor"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "Hızı 1x’e sabitle"
  },
  "locked_762f138b": {
    "message": "Kilitli"
  },
  "logical_equivalence_76fca396": {
    "message": "Mantıksal Eşdeğerlik"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Mantıksal Eşdeğerlik (Kısa)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Mantıksal Eşdeğerlik (Kısa ve Kalın)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Mantıksal Eşdeğerlik (Kalın)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Düşük yatay noktalar"
  },
  "magenta_4a65993c": {
    "message": "Macenta"
  },
  "maps_to_e5ef7382": {
    "message": "Eşler"
  },
  "math_icon_ad4e9d03": {
    "message": "Matematik Simgesi"
  },
  "media_af190855": {
    "message": "Medya"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "Medya dosyası işleniyor. Lütfen daha sonra yeniden deneyin."
  },
  "media_options_saved_560c4ec8": {
    "message": "Medya seçenekleri kaydedildi."
  },
  "media_title_2112243b": {
    "message": "Medya Başlığı"
  },
  "medium_5a8e9ead": {
    "message": "Üye"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "Orta ({ width } x { height } px)"
  },
  "merge_links_2478df96": {
    "message": "Bağlantıları birleştir"
  },
  "mic_a7f3d311": {
    "message": "Mikrofon"
  },
  "microphone_disabled_15c83130": {
    "message": "Mikrofon Devre Dışı"
  },
  "middle_27dc1d5": {
    "message": "Orta"
  },
  "minimize_file_preview_da911944": {
    "message": "Dosya Ön İzlemesini Küçült"
  },
  "minimize_video_20aa554b": {
    "message": "Video''yu Küçült"
  },
  "minus_fd961e2e": {
    "message": "Eksi"
  },
  "minus_plus_3461f637": {
    "message": "Eksi/Artı"
  },
  "misc_3b692ea7": {
    "message": "Çeşitli"
  },
  "miscellaneous_e9818229": {
    "message": "Çeşitli"
  },
  "module_90d9fd32": {
    "message": "Modül"
  },
  "modules_c4325335": {
    "message": "Modüller"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Görseli kırpmak için { directionWord } yönüne taşı"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Çok Renkli Görsel"
  },
  "multiplication_sign_15f95c22": {
    "message": "Çarpma İşareti"
  },
  "music_icon_4db5c972": {
    "message": "Müzik Simgesi"
  },
  "my_files_2f621040": {
    "message": "Dosyalarım"
  },
  "n_th_root_9991a6e4": {
    "message": "N’inci Kök"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "İsim"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Natürel (Müzik)"
  },
  "natural_numbers_3da07060": {
    "message": "Doğal Sayılar"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Menüde veya araç çubuğunda gezinin"
  },
  "navigation_ee9af92d": {
    "message": "Gezinme"
  },
  "nested_greater_than_d852e60d": {
    "message": "İç içe büyüktür"
  },
  "nested_less_than_27d17e58": {
    "message": "İç içe küçüktür"
  },
  "new_quiz_34aacba6": {
    "message": "Yeni Kısa Sınav"
  },
  "next_40e12421": {
    "message": "Sonraki"
  },
  "next_findtext_9d69f0fe": {
    "message": "Sonraki { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Herhangi bir erişilebilirlik sorunu tespit edilmedi."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Henüz duyuru oluşturulmadı."
  },
  "no_announcements_found_20185afc": {
    "message": "Duyuru bulunamadı."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Henüz ödev oluşturulmadı."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Ödev bulunamadı."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Kaydedilecek değişiklik yok."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Henüz tartışma oluşturulmadı."
  },
  "no_discussions_found_9284063b": {
    "message": "Tartışma bulunamadı."
  },
  "no_e16d9132": {
    "message": "Hayır"
  },
  "no_file_chosen_9a880793": {
    "message": "Dosya seçilmedi"
  },
  "no_headers_9bc7dc7f": {
    "message": "Başlık yok"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Henüz modül oluşturulmadı."
  },
  "no_modules_found_2df43a40": {
    "message": "Modül bulunamadı."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Sayfa henüz oluşturulmadı."
  },
  "no_pages_found_6799350": {
    "message": "Sayfa bulunamadı."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Bu dosya için ön izleme bulunmamaktadır."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Henüz kısa sınav oluşturulmadı."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Sınav bulunamadı."
  },
  "no_results_940393cf": {
    "message": "Sonuç yok."
  },
  "no_results_found_58717065": {
    "message": "Sonuç bulunamadı"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Sonuç bulunamadı: { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Video Yok"
  },
  "none_3b5e34d2": {
    "message": "Yok"
  },
  "none_selected_b93d56d2": {
    "message": "Seçili değil"
  },
  "normal_text_7b03da48": {
    "message": "Normal metin"
  },
  "not_equal_6e2980e6": {
    "message": "Eşit Değil"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "∉ (Elemanı Değildir)"
  },
  "not_negation_1418ebb8": {
    "message": "Değil (Olumsuzlama)"
  },
  "not_subset_dc2b5e84": {
    "message": "Alt Küme Değil"
  },
  "not_subset_strict_23d282bf": {
    "message": "Alt Küme Değil (Sıkı)"
  },
  "not_superset_5556b913": {
    "message": "Üst Küme Değil"
  },
  "not_superset_strict_24e06f36": {
    "message": "Üst Küme Değil (Sıkı)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "Sekizgen"
  },
  "olive_6a3e4d6b": {
    "message": "Zeytin"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "Bir simgeyi kaydetmek için şu stillerden en az biri eklenmelidir: Simge Rengi, Anahat Boyutu, Simge Metni veya Görsel"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Bir veya daha fazla dosya yapıştırılamadı. Lütfen yüklemeyi veya sürükle-bırak yöntemini deneyin."
  },
  "open_circle_e9bd069": {
    "message": "Açık Çember"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Bu klavye kısayolları penceresini aç"
  },
  "open_title_application_fd624fc5": {
    "message": "{ title } uygulamasını aç"
  },
  "operators_a2ef9a93": {
    "message": "Operatörler"
  },
  "options_3ab0ea65": {
    "message": "Seçenekler"
  },
  "or_9b70ccaa": {
    "message": "Veya"
  },
  "orange_81386a62": {
    "message": "Turuncu"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Sıralı ve Sırasız Listeler"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Diğer düzenleyici kısayolları şurada bulunabilir:"
  },
  "outline_color_3ef2cea7": {
    "message": "Anahat Rengi"
  },
  "outline_size_a6059a21": {
    "message": "Anahat Boyutu"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } geçerli bir protokol değil."
  },
  "page_50c4823d": {
    "message": "Sayfa"
  },
  "pages_e5414c2c": {
    "message": "Sayfalar"
  },
  "paragraph_5e5ad8eb": {
    "message": "Paragraf"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Paragraf uygulandı"
  },
  "paragraph_removed_d09320e": {
    "message": "Paragraf kaldırıldı"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "{ start } ile başlayan paragraf"
  },
  "parallel_d55d6e38": {
    "message": "Paralel"
  },
  "partial_derivative_4a9159df": {
    "message": "Kısmi (Türev)"
  },
  "pass_1c19a2b3": {
    "message": "GEÇTİ"
  },
  "paste_5963d1c1": {
    "message": "Yapıştır"
  },
  "pause_12af3bb4": {
    "message": "Duraklat"
  },
  "pentagon_17d82ea3": {
    "message": "Beşgen"
  },
  "people_b4ebb13c": {
    "message": "Katılımcılar"
  },
  "percentage_34ab7c2c": {
    "message": "Yüzde"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Yüzde bir sayı olmalıdır"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "Yüzde en az { percentage }% olmalıdır"
  },
  "performing_arts_icon_f3497486": {
    "message": "Sahne Sanatları Simgesi"
  },
  "perpendicular_7c48ede4": {
    "message": "Dik"
  },
  "phi_4ac33b6d": {
    "message": "Phi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Phi (Varyant)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Beden Eğitimi Simgesi"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (Varyant)"
  },
  "pick_a_color_557abfb0": {
    "message": "Renk seçin"
  },
  "pink_68ad45cb": {
    "message": "Pembe"
  },
  "pixels_52ece7d1": {
    "message": "Piksel"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Piksel en az { width } x { height } px olmalıdır"
  },
  "play_1a47eaa7": {
    "message": "Oynat"
  },
  "play_media_comment_35257210": {
    "message": "Medya yorumunu oynat."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "{ createdAt } tarihinde { name } tarafından yapılan medya yorumunu oynat."
  },
  "player_layout_14e09a29": {
    "message": "Oynatıcı düzeni"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Lütfen Canvas''ın mikrofonunuza ve web kameranıza erişmesine izin verin."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Lütfen bir dosya seçin"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Lütfen bir dosya adı girin"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Desteklenen bir platformdan geçerli bir video URL’si girin."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Desteklenen türde bir dosya seçin"
  },
  "plus_d43cd4ec": {
    "message": "Artı"
  },
  "plus_minus_f8be2e83": {
    "message": "Artı/Eksi"
  },
  "posted_when_a578f5ab": {
    "message": "Yayınlandı: { when }"
  },
  "power_set_4f26f316": {
    "message": "Kuvvet Kümesi"
  },
  "precedes_196b9aef": {
    "message": "Önceler"
  },
  "precedes_equal_20701e84": {
    "message": "Önceler veya Eşittir"
  },
  "preformatted_d0670862": {
    "message": "Önceden biçimlendirilmiş"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Önceki"
  },
  "preview_53003fd2": {
    "message": "Önizleme"
  },
  "preview_a3f8f854": {
    "message": "ÖN İZLEME"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Kaplama üzerinde önizle"
  },
  "preview_inline_9787330": {
    "message": "Satır içi önizle"
  },
  "previous_bd2ac015": {
    "message": "Önceki"
  },
  "previous_findtext_8dfbfd30": {
    "message": "Önceki { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Daha önce seçilen renkler"
  },
  "prime_917ea60e": {
    "message": "Asal"
  },
  "prime_numbers_13464f61": {
    "message": "Asal Sayılar"
  },
  "product_39cf144f": {
    "message": "Çarpım"
  },
  "proportional_f02800cc": {
    "message": "Orantılı"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Protokol ftp, http, https, mailto, skype, tel olmalıdır ya da boş bırakılabilir"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "yayınlandı"
  },
  "published_when_302d8e23": {
    "message": "Yayımlandı: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Balkabağı"
  },
  "purple_7678a9fc": {
    "message": "Mor"
  },
  "quaternions_877024e0": {
    "message": "Kuaterniyonlar"
  },
  "quiz_e0dcce8f": {
    "message": "Kısa Sınav"
  },
  "quizzes_7e598f57": {
    "message": "Kısa sınavlar"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Rasyonel Sayılar"
  },
  "real_numbers_7c99df94": {
    "message": "Gerçek Sayılar"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Gerçek Kısım (Karmaşık Sayı)"
  },
  "record_7c9448b": {
    "message": "Kayıt"
  },
  "record_upload_media_5fdce166": {
    "message": "Medya Kaydet/Yükle"
  },
  "recording_98da6bda": {
    "message": "Kaydediliyor"
  },
  "red_8258edf3": {
    "message": "Kırmızı"
  },
  "relationships_6602af70": {
    "message": "İlişkiler"
  },
  "religion_icon_246e0be1": {
    "message": "Din Simgesi"
  },
  "remove_f47dc62a": {
    "message": "Kaldır"
  },
  "remove_filename_3ea029f6": {
    "message": "{ filename } kaldır"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Başlık stilini kaldır"
  },
  "remove_link_d1f2f4d0": {
    "message": "Bağlantıyı Kaldır"
  },
  "replace_all_d3d68b3": {
    "message": "Tümünü Değiştir"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Tüm { findText } öğelerini { replaceText } ile değiştir"
  },
  "replace_e61834a7": {
    "message": "Değiştir"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "{ findText } öğesini { replaceText } ile değiştir"
  },
  "replace_with_eeff01ad": {
    "message": "Şununla değiştir"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "{ alertFindText }, { alertReplaceText } ile değiştirildi"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Tüm { alertFindText } öğeleri { alertReplaceText } ile değiştirildi"
  },
  "reset_95a81614": {
    "message": "Sıfırla"
  },
  "resize_ec83d538": {
    "message": "Yeniden boyutlandır"
  },
  "restore_auto_save_deccd84b": {
    "message": "Otomatik kaydı geri yüklemek ister misiniz?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "{ index } / { max } sonucu."
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Ters Turnike (Sonuç Vermez)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (Varyant)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Zengin İçerik Editörü"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Zengin Metin Alanı. Zengin İçerik Düzenleyicisi kısayolları için { OSKey }+F8’e basın."
  },
  "right_71ffdc4d": {
    "message": "Sağ"
  },
  "right_align_39e7a32a": {
    "message": "Sağa hizala"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Sağ açılı ayraç"
  },
  "right_arrow_35e0eddf": {
    "message": "Sağ ok"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Kancalı sağ ok"
  },
  "right_ceiling_839dc744": {
    "message": "Sağ tavan"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Sağ kıvrımlı ayraç"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Sağ aşağı zıpkın oku"
  },
  "right_floor_5392d5cf": {
    "message": "Sağ taban"
  },
  "right_to_left_9cfb092a": {
    "message": "Sağdan Sola"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Sağ yukarı zıpkın oku"
  },
  "rightward_arrow_32932107": {
    "message": "Sağa ok"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Sağa bakan üçgen"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Görseli -90 derece döndür"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Görseli 90 derece döndür"
  },
  "rotation_9699c538": {
    "message": "Döndürme"
  },
  "row_fc0944a7": {
    "message": "Satır"
  },
  "row_group_979f5528": {
    "message": "Satır grubu"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Ne yazık ki biçimlendirilmiş HTML düzenleyicisine klavye ile erişilemiyor. Ham HTML düzenleyicisine buradan erişin."
  },
  "save_11a80ec3": {
    "message": "Kaydet"
  },
  "save_copy_ca63944e": {
    "message": "Kopyayı Kaydet"
  },
  "save_media_cb9e786e": {
    "message": "Medyayı Kaydet"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Kaydedilmiş Simge Oluşturucu Simgeleri"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Ekran okuyucular, alternatif metin olmadan bir görselde ne gösterildiğini belirleyemez; dosya adları ise çoğu zaman anlam taşımayan sayı ve harf dizileridir ve bağlamı ya da anlamı açıklamaz."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Ekran okuyucular, alternatif metin olmadan bir görselde ne gösterildiğini belirleyemez. Alternatif metin, görselin içeriğini ve anlamını açıklamalıdır. Alternatif metin basit ve öz olmalıdır."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Ekran okuyucular, alternatif metin olmadan bir görselde ne gösterildiğini belirleyemez; alternatif metin, görselin içeriğini ve anlamını açıklamalıdır."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Ekran okuyucular, doğru yapı olmadan tabloları yorumlayamaz. Tablo başlıkları yön ve içerik kapsamı sağlar."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Ekran okuyucular, doğru yapı olmadan tabloları yorumlayamaz. Tablo altyazıları, tablonun bağlamını ve genel anlaşılmasını açıklar."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Ekran okuyucular, doğru yapı olmadan tabloları yorumlayamaz. Tablo başlıkları içerik için yön ve genel bakış sağlar."
  },
  "script_l_42a7b254": {
    "message": "Betik L"
  },
  "search_280d00bd": {
    "message": "Ara"
  },
  "select_audio_source_21043cd5": {
    "message": "Ses kaynağı seçin"
  },
  "select_crop_shape_d441feeb": {
    "message": "Kırpma şeklini seçin"
  },
  "select_language_7c93a900": {
    "message": "Dil Seçin"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Video kaynağı seçin"
  },
  "selected_274ce24f": {
    "message": "Seçildi"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Seçildi: { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Seçim"
  },
  "set_header_scope_8c548f40": {
    "message": "Başlık kapsamını ayarla"
  },
  "set_minus_b46e9b88": {
    "message": "Eksi işareti ayarla"
  },
  "set_table_header_cfab13a0": {
    "message": "Tablo başlığı ayarla"
  },
  "sharp_music_ab956814": {
    "message": "Diyez (Müzik)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+Oklar"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Shift+O ile biçimlendirilmiş HTML düzenleyicisini açın."
  },
  "shortcut_911d6255": {
    "message": "Kısayol"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Görsel seçeneklerini göster"
  },
  "show_link_options_545338fd": {
    "message": "Bağlantı seçeneklerini göster"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Gören kullanıcılar web sayfalarına hızlıca göz atar ve büyük veya kalın başlıklara bakar. Ekran okuyucu kullanıcıları bağlamı anlamak için başlıklara dayanır. Başlıklar doğru yapıyı kullanmalıdır."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Gören kullanıcılar web sayfalarına hızlıca göz atar ve büyük veya kalın başlıklara bakar. Ekran okuyucu kullanıcıları bağlamı anlamak için başlıklara dayanır. Başlıklar doğru yapı içinde öz olmalıdır."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (Varyant)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Tek Renkli Görsel"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Tek Renkli Görsel Rengi"
  },
  "size_b30e1077": {
    "message": "Boyut"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "Altyazı dosyası boyutu, izin verilen azami { max } KB dosya boyutundan daha büyük."
  },
  "small_b070434a": {
    "message": "Küçük"
  },
  "small_width_x_height_px_359acd38": {
    "message": "Küçük ({ width } x { height } px)"
  },
  "solid_circle_9f061dfc": {
    "message": "Dolu Çember"
  },
  "something_went_wrong_89195131": {
    "message": "Bazı sorunlar oluştu."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Web kameranıza erişilirken bir sorun oluştu."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Bir şeyler ters gitti ve size ne göstereceğimi bilmiyorum."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Bir şeyler ters gitti. Bağlantınızı kontrol edin, sayfayı yenileyin ve tekrar deneyin."
  },
  "something_went_wrong_d238c551": {
    "message": "Bir sorun oluştu"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Ekran paylaşılırken bir hata oluştu."
  },
  "sort_by_e75f9e3e": {
    "message": "Sırala"
  },
  "spades_suit_b37020c2": {
    "message": "Maça (İskambil)"
  },
  "square_511eb3b3": {
    "message": "Kare"
  },
  "square_cap_9ec88646": {
    "message": "Kare Cap"
  },
  "square_cup_b0665113": {
    "message": "Kare Cup"
  },
  "square_root_e8bcbc60": {
    "message": "Karekök"
  },
  "square_root_symbol_d0898a53": {
    "message": "Karekök Simgesi"
  },
  "square_subset_17be67cb": {
    "message": "Kare Alt Küme"
  },
  "square_subset_strict_7044e84f": {
    "message": "Kare Alt Küme (Sıkı)"
  },
  "square_superset_3be8dae1": {
    "message": "Kare Üst Küme"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Kare Üst Küme (Sıkı)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "kare sırasız liste"
  },
  "star_8d156e09": {
    "message": "Yıldız"
  },
  "start_over_f7552aa9": {
    "message": "Baştan Başla"
  },
  "start_recording_9a65141a": {
    "message": "Kaydı Başlat"
  },
  "steel_blue_14296f08": {
    "message": "Çelik Mavisi"
  },
  "studio_media_options_ee504361": {
    "message": "Studio Medya Seçenekleri"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Studio Medya Seçenekleri Tepsisi"
  },
  "styles_2aa721ef": {
    "message": "Stiller"
  },
  "submit_a3cc6859": {
    "message": "Gönder"
  },
  "submitting_b90fac62": {
    "message": "Gönderiliyor..."
  },
  "subscript_59744f96": {
    "message": "Alt indis"
  },
  "subset_19c1a92f": {
    "message": "Alt küme"
  },
  "subset_strict_8d8948d6": {
    "message": "Alt küme (Sıkı)"
  },
  "succeeds_9cc31be9": {
    "message": "İzler"
  },
  "succeeds_equal_158e8c3a": {
    "message": "İzler veya Eşittir"
  },
  "sum_b0842d31": {
    "message": "Toplam"
  },
  "superscript_8cb349a2": {
    "message": "Üst indis"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Üst indis ve Alt indis"
  },
  "superset_c4db8a7a": {
    "message": "Üst küme"
  },
  "superset_strict_c77dd6d2": {
    "message": "Üst küme (Sıkı)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Desteklenen dosya türleri: SRT veya WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Biçimlendirilmiş HTML Düzenleyicisine geç"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Ham HTML Düzenleyicisine geç"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "HTML düzenleyicisine geç"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Zengin metin düzenleyicisine geç"
  },
  "syllabus_f191f65b": {
    "message": "Ders Programı"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Sistem Sesi Etkin"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Sistem Sesi Devre Dışı"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/Oklar"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "{ start } ile başlayan tablo başlığı"
  },
  "table_starting_with_start_e7232848": {
    "message": "{ start } ile başlayan tablo"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Tablo başlıkları kapsamı belirtmelidir."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Tablolarda, tablonun içeriğini açıklayan bir açıklama bulunmalıdır."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Tablolar en az bir başlık içermelidir."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Turkuaz"
  },
  "text_7f4593da": {
    "message": "Metin"
  },
  "text_background_color_16e61c3f": {
    "message": "Metin Arka Plan Rengi"
  },
  "text_color_acf75eb6": {
    "message": "Metin Rengi"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "Metin ile arka plan arasında yeterli kontrast olmadığında metni okumak zordur; özellikle düşük görme düzeyine sahip kullanıcılar için."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "18 punto’dan büyük metin (veya 14 punto kalın metin), en az 3:1 kontrast oranı göstermelidir."
  },
  "text_optional_384f94f7": {
    "message": "Metin (isteğe bağlı)"
  },
  "text_position_8df8c162": {
    "message": "Metin Konumu"
  },
  "text_size_887c2f6": {
    "message": "Metin Boyutu"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "18 punto’dan küçük metin (veya 14 punto kalın metin), en az 4,5:1 kontrast oranı göstermelidir."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Döküman ön izlemesi hala işleniyor. Lütfen daha sonra tekrar deneyin."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "Bir sayfadaki ilk başlık H2 olmalıdır."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "Zengin İçerik Alanı yüksekliği azaltıldı."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "Zengin İçerik Alanı yüksekliği artırıldı."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Bu malzeme genel kullanıma açık"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Bu malzeme Creative Commons a göre lisanslı"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "The material is subject to an exception - e.g. fair use, the right to quote, or others under applicable copyright laws"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "Biçimlendirilmiş HTML düzenleyicisine klavye ile erişilemiyor. Ham HTML düzenleyicisini açmak için Shift+O’ya basın."
  },
  "therefore_d860e024": {
    "message": "Bu nedenle"
  },
  "theta_ce2d2350": {
    "message": "Theta"
  },
  "theta_variant_fff6da6f": {
    "message": "Theta (Varyant)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Kalın aşağı ok"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Kalın sol ok"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Kalın sola ok"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Kalın sağ ok"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Kalın sağa ok"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Kalın yukarı ok"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Bu belge Canvas içinde görüntülenemez."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Bu denklem Temel Görünümde işlenemez."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Bu görsel şu anda kullanılamıyor"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "Bu video YouTube reklamları gösterebilir."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Videonuz tarayıcıda doğru başlığa sahip olsa da, veritabanında güncelleyemedik."
  },
  "thumbnail_e0de666f": {
    "message": "Küçük resim"
  },
  "timebar_a4d18443": {
    "message": "Zaman çubuğu"
  },
  "title_ee03d132": {
    "message": "Başlık"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "Gönderileceği zaman: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Yapılacak: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "{ summary } grubunu aç/kapat"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Araç ipucunu aç/kapat"
  },
  "tools_2fcf772e": {
    "message": "Araçlar"
  },
  "top_66e0adb6": {
    "message": "Üst"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "Transkript paneli 720 px üzerindeki genişliklerde kullanılabilir."
  },
  "tray_839df38a": {
    "message": "Yan menü"
  },
  "triangle_6072304e": {
    "message": "Üçgen"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Turnike (Sonuç Verir)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "görsel seçeneklerine ulaşmak için Kontrol F9 tuşuna basın. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "Erişim bağlantısı seçeneklerine ulaşmak için Kontrol F9 tuşuna basın. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "Erişim tablosu seçeneklerine ulaşmak için Kontrol F9 tuşuna basın. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Kaynak seçim URL’si belirlenemedi"
  },
  "underline_applied_ae01ec97": {
    "message": "Altı çizili uygulandı"
  },
  "underline_removed_3693e17c": {
    "message": "Altı çizili kaldırıldı"
  },
  "union_e6b57a53": {
    "message": "Birleşim"
  },
  "unpublished_dfd8801": {
    "message": "yayınlanmadı"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "Kaydedilmemiş değişiklikler kaybolacak."
  },
  "untitled_16aa4f2b": {
    "message": "Başlıksız"
  },
  "untitled_efdc2d7d": {
    "message": "Başlıksız"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Yukarı ve sola çapraz ok"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Yukarı ve sağa çapraz ok"
  },
  "up_c553575d": {
    "message": "Yukarı"
  },
  "updated_link_a827e441": {
    "message": "Güncellenmiş bağlantı"
  },
  "upload_document_253f0478": {
    "message": "Belge Yükle"
  },
  "upload_file_fd2361b8": {
    "message": "Dosya Yükle"
  },
  "upload_image_6120b609": {
    "message": "Görsel Yükle"
  },
  "upload_media_ce31135a": {
    "message": "Medya Dosyası Yükle"
  },
  "upload_record_media_e4207d72": {
    "message": "Medya Yükle/Kaydet"
  },
  "uploading_19e8a4e7": {
    "message": "Yükleniyor"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "Büyük harf alfabetik sıralı liste"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Büyük Delta"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Büyük Gamma"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Büyük Lambda"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Büyük Omega"
  },
  "uppercase_phi_caa36724": {
    "message": "Büyük Phi"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Büyük Pi"
  },
  "uppercase_psi_6395acbe": {
    "message": "Büyük Psi"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "büyük harfli Romen rakamı sıralı liste"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Büyük Sigma"
  },
  "uppercase_theta_49afc891": {
    "message": "Büyük Theta"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Büyük Upsilon"
  },
  "uppercase_xi_341e8556": {
    "message": "Büyük Xi"
  },
  "upsilon_33651634": {
    "message": "Upsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Yukarı ve aşağı bakan ok"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Yukarı ve aşağı bakan ok (Kalın)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Yukarı ok"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Yukarı bakan üçgen"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Kullanım Şartları:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Kullanım Hakları (zorunlu)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Seçeneklerde gezinmek için ok tuşlarını kullanın."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Bir şekil seçmek için ok tuşlarını kullanın."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Bir boyut seçmek için ok tuşlarını kullanın."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Bir metin konumu seçmek için ok tuşlarını kullanın."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Bir metin boyutu seçmek için ok tuşlarını kullanın."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Bir anahat boyutu seçmek için ok tuşlarını kullanın."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Ekran okuyucular tarafından bir { TYPE } içeriğini tanımlamak için kullanılır"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Ekran okuyucuları tarafından bir görselin içeriğini açıklamak için kullanılır"
  },
  "user_documents_c206e61f": {
    "message": "Kullanıcı Belgeleri"
  },
  "user_files_78e21703": {
    "message": "Kullanıcı Dosyaları"
  },
  "user_images_b6490852": {
    "message": "Kullanıcı Görselleri"
  },
  "user_media_14fbf656": {
    "message": "Kullanıcı Medya Dosyası"
  },
  "vector_notation_cf6086ab": {
    "message": "Vektör (Gösterim)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Dikey Çizgi (Küme Kurma Gösterimi)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Dikey noktalar"
  },
  "video_options_24ef6e5d": {
    "message": "Video Seçenekleri"
  },
  "video_options_tray_3b9809a5": {
    "message": "Video Seçenekleri Yan Menüsü"
  },
  "video_player_b371005": {
    "message": "Video Oynatıcı"
  },
  "video_player_for_9e7d373b": {
    "message": "Şunun için video oynatıcı: "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "{ title } için video oynatıcı"
  },
  "video_url_889d3263": {
    "message": "Video URL’si"
  },
  "view_all_e13bf0a6": {
    "message": "Tümünü Görüntüle"
  },
  "view_ba339f93": {
    "message": "Göster"
  },
  "view_description_30446afc": {
    "message": "Açıklamayı görüntüle"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Klavye Kısayollarını Göster"
  },
  "view_title_description_67940918": {
    "message": "{ title } açıklamasını görüntüle"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Kelime ve karakter sayılarını görüntüle"
  },
  "viewer_restrictions_e14274c9": {
    "message": "İzleyici Kısıtlamaları"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Cihazınıza bağlı çalışan bir mikrofon algılayamadık."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Cihazınıza bağlı çalışan bir web kamerası algılayamadık."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Cihazınıza bağlı çalışan bir web kamerası veya mikrofon algılayamadık."
  },
  "webcam_disabled_30c66986": {
    "message": "Web kamerası devre dışı"
  },
  "webcam_fe91b20f": {
    "message": "Web Kamerası"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Web sayfalarında yalnızca tek bir H1 olmalıdır; bu başlık otomatik olarak sayfanın Başlığı tarafından kullanılır. İçeriğinizdeki ilk başlık H2 olmalıdır."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Liste gibi görünen ancak liste ilişkisini belirtmeyen biçimlendirme kullanıldığında, kullanıcılar bilgide gezinmekte zorlanabilir."
  },
  "white_87fa64fd": {
    "message": "Beyaz"
  },
  "why_523b3d8c": {
    "message": "Neden"
  },
  "width_492fec76": {
    "message": "Genişlik"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Genişlik ve yükseklik rakam olmalı"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "Wiki Ana Sayfası"
  },
  "word_count_c77fe3a6": {
    "message": "Kelime Sayısı"
  },
  "words_b448b7d5": {
    "message": "Kelimeler"
  },
  "wreath_product_200b38ef": {
    "message": "Çelenk Çarpımı"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "Evet"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Bir renk paletindesiniz. Palet üzerinde yukarı, sola, aşağı veya sağa gitmek için sırasıyla ''W'', ''A'', ''S'' ve ''D'' tuşlarını kullanın"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Bir renk kaydırıcısındasınız. Kaydırıcıda sola veya sağa gitmek için sırasıyla ''A'' ve ''D'' tuşlarını kullanın"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Bir alfa kaydırıcısındasınız. Kaydırıcıda sola veya sağa gitmek için sırasıyla ''A'' ve ''D'' tuşlarını kullanın"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Simge Oluşturucu tepsisinde kaydedilmemiş değişiklikler var. Bu değişiklikleri kaydetmeden devam etmek istiyor musunuz?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Sayfa hiyerarşisini korumak için ek başlıkları ayarlamanız gerekebilir."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Boş bir dosya yükleyemezsiniz."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Görseliniz Simge Oluşturucu için sıkıştırıldı. { size } KB’den küçük görseller sıkıştırılmayacaktır."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Mikrofonunuz tarayıcı ayarlarında engellenmiş."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Web kameranız ve mikrofonunuz tarayıcı ayarlarında engellenmiş."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Web kameranız tarayıcı ayarlarında engellenmiş."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Web kameranız kullanılıyor olabilir."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "YouTube gömme URL’si"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Görseli yakınlaştır"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Görseli uzaklaştır"
  }
};
formatMessage.addLocale({
  tr: locale
});